import { Button, Icon } from "@pepperstone/pepper-ui-kit";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { components, type MenuProps } from "react-select";
import { InputFieldBase } from "@/components/forms/input-field-base/InputFieldBase";
import { SearchContext } from "@/pages/withdrawals/choose-method/payment-method-selector-card/components/SearchContext";
import type { SelectMenuItemType } from "@/pages/withdrawals/choose-method/payment-method-selector-card/types";
import style from "./SelectMenu.module.css";

export const SelectMenu = ({
  children,
  ...props
}: MenuProps<SelectMenuItemType, false>) => {
  const { t } = useTranslation();
  const { setSearchValue, searchValue, setListMode, listMode } =
    useContext(SearchContext);
  return (
    <components.Menu {...props}>
      <div
        className="ps-flex ps-flex-col ps-gap-4 ps-p-4"
        data-testid="withdrawal-methods-selector-select-menu"
      >
        <InputFieldBase
          size="md"
          data-testid="withdrawal-methods-selector-select-search-field"
          classNames={{ inputContainer: style.searchInputContainer }}
          hideErrorPlaceholder={true}
        >
          <Icon icon="search" />
          <input
            data-testid="withdrawal-methods-selector-select-search-input"
            placeholder={t(
              "withdrawals.methods.payment_method_selector_card.search_payment_methods"
            )}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onClick={(e) => {
              if (document.activeElement !== e.target) {
                (e.target as HTMLInputElement).focus();
              }
            }}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
          />
        </InputFieldBase>

        <div className={"ps-flex ps-gap-2"}>
          <Button
            data-testid="withdrawal-methods-selector-select-type-saved"
            type="button"
            size="ps-btn-xs"
            variant={
              listMode === "saved" ? "ps-btn-selected" : "ps-btn-secondary"
            }
            onClick={() => {
              setListMode("saved");
              setSearchValue("");
            }}
          >
            {t("withdrawals.methods.payment_method_selector_card.saved")}
          </Button>
          <Button
            data-testid="withdrawal-methods-selector-select-type-new"
            type="button"
            size="ps-btn-xs"
            variant={
              listMode !== "saved" ? "ps-btn-selected" : "ps-btn-secondary"
            }
            onClick={() => {
              setListMode("new");
              setSearchValue("");
            }}
          >
            {t("withdrawals.methods.payment_method_selector_card.new")}
          </Button>
        </div>
      </div>
      <div
        className={"ps-mb-4"}
        data-testid={"withdrawal-methods-selector-select-menu-items-container"}
      >
        {children}
      </div>
    </components.Menu>
  );
};
